/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundImagePickerContainer_user$ref: FragmentReference;
export type BackgroundImagePickerContainer_user = {|
  +backgroundImage: ?{|
    +id: string,
    +imageURL: ?string,
  |},
  +$refType: BackgroundImagePickerContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundImagePickerContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "backgroundImage",
      "storageKey": null,
      "args": null,
      "concreteType": "BackgroundImage",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageURL",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '943a2513955f178bd4109a26f96224f2';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Background/__generated__/BackgroundImagePickerContainer_user.graphql.js